<template>
	<ms-popup
		:active.sync="active"
		@close="closePopup"
		:width="config && config.width ? config.width : 400"
		:height="config && config.height ? config.height : 282"
		:autoFocus="false"
		:forceRender="true"
		:posZ="1200"
		class="ms-message-toast"
	>
		<template slot="content">
			<components :is="config.template" v-if="config.template"></components>
			<div class="flex-box align-center w-full h-full msg-toast" v-else>
				<div class="img-confirm flex flex-1 items-center">
					<img :src="imgLink" :style="getStyleImage" />
				</div>
				<div class="title-header-form ms-line-height-22px ms-mgt-20px">
					{{
						config && config.title
							? config.title
							: $t('i18nCommon.Notification')
					}}
				</div>
				<div
					class="msg text-center ms-mgt-4px ms-line-height-20px"
					v-html="config.message"
				></div>
				<div class="btn-msg ms-mgt-20px ms-width-80px" v-if="config.button">
					<ms-button
						:title="config.button.title"
						@click="btnAction"
						cssClass="btn-toast"
					></ms-button>
				</div>
			</div>
		</template>
	</ms-popup>
</template>
<script>
export default {
	name: 'msMessagesToast',
	data() {
		return {
			active: false,
			config: {
				type: this.$ms.enum.msgToastType.Success,
				message: null,
				icon: null,
				template: null,
				time: null,
				button: null,
				isShowTitle: false,
				title: null,
				width: 400,
				height: 300,
			},
		};
	},
	computed: {
		imgLink() {
			const me = this;
			if (me.config.type == me.$ms.enum.msgToastType.Success) {
				return require('@/assets/images/icons/success-bot.png');
			} else if (me.config.type == me.$ms.enum.msgToastType.Error) {
				return require('@/assets/images/icons/Mascot_7.png');
			}
			return null;
		},
		getStyleImage() {
			const me = this;
			if (me.config && me.config.type == me.$ms.enum.msgToastType.Error) {
				return {
					width: '116px',
					height: '117px',
				};
			}
			return {};
		},
	},
	methods: {
		showPopup(config) {
			const me = this;
			me.config = config;
			if (me.config.time) {
				setTimeout(() => {
					me.closePopup();
				}, me.config.time);
			}
			me.$nextTick(() => {
				me.active = true;
			});
		},
		btnAction() {
			const me = this;
			if (me.config.button && typeof me.config.button.action == 'function') {
				me.config.button.action();
			}
			me.active = false;
		},
		closePopup() {
			const me = this;
			me.active = false;
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msMessageToast.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msMessageToast.scss';
}
</style>
